import { useQuery } from '@tanstack/react-query';
import useUser from '../global/useUser';
import useGetMarketingData from './useGetMarketingData';
import { getAdsAnalytics } from '../../services/ads';

function useGetAdsAnalytics() {
  const { user } = useUser();
  const { data: marketingData } = useGetMarketingData();

  const businessId = user?.business?.id;
  const adsUrl = marketingData?.adsUrl;

  return useQuery({
    queryKey: ['ads-analytics-embed', businessId, adsUrl],
    queryFn: () => getAdsAnalytics({ businessId }),
    enabled: !!marketingData?.sourceBusinessId && !!businessId,
  });
}

export default useGetAdsAnalytics;
